import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9k8cb79ew4: FaireBrandEntity = {
  token: "b_9k8cb79ew4",
  type: "brand",
  name: "Blueyejewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/43dd6c337d1f1097f4cb7660759f88dadd2cf25fd2f56c899ed914432f119f49.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/24907608a74acf6c0f342768e23d1741a2ca8596cc407c473c18dfad0f4c13b6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/43dd6c337d1f1097f4cb7660759f88dadd2cf25fd2f56c899ed914432f119f49.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/24907608a74acf6c0f342768e23d1741a2ca8596cc407c473c18dfad0f4c13b6.jpeg",
  location: "Edmonton, AB, CAN",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 193,
  isTopShop: true,
  isInsider: false,
  description:
    "Hey there! Welcome to BEJ, we’re so glad you’re here!\n\n***For US customers: No surprise tariff or brokerage fees. Any fees shown at checkout are fully covered upfront, with no extra charges on delivery. We take care of everything so customs is seamless for you.\n\nWe’re a Canadian, woman-owned jewelry brand shipping directly from our studio in Beaumont, AB, Canada. Our collection includes unique designs and many handmade, personalized pieces you won’t find anywhere else. We work with PVD plated stainless steel (waterproof, built to last) and sterling silver.\n\nWhat you see here is real. We don’t use AI images, digital mockups, or AI models. All product photos are of the actual pieces that are photographed in our studio, so there are no surprises.\n\nWe take pride in creating jewelry that combines quality, style, and a personal touch. From our studio to your store, every piece is made with care, ready to offer your customers something special and stand out on the shelf. Thank you for supporting our woman-owned Canadian business!\n\nBEJ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:06.647Z",
    importedBy: "entity-db-cli",
  },
};
